import { Box, Typography, styled, IconButton } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: "32px",
  gap: "16px",
});

export const TitleWrap = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: 1,
  minWidth: 0,
});

export const TitleRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  minWidth: 0,
});

export const PageTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
  lineHeight: "32px",
});

export const TitleEditRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  minWidth: 0,
});

export const TitleInputWrap = styled(Box)({
  flex: 1,
  minWidth: 0,
  maxWidth: "636px",
  marginRight: "12px",
  "& .MuiInputBase-input": {
    fontSize: "24px",
    fontFamily: "Sora, sans-serif",
    fontWeight: 600,
    lineHeight: "32px",
  },
});

export const MetaRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
});

export const MetaContainer = styled(Box)({
  display: "flex",
  gap: "8px",
  alignItems: "center",
});

export const MetaItem = styled(Typography)({
  fontFamily: "Nunito",
  fontSize: "16px",
  color: colors.text.secondary,
});

export const HeaderActions = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-end",
  flexShrink: 0,
  gap: "16px",
  whiteSpace: "nowrap",
  "& button": {
    gap: "8px",
  },
});

export const EditIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const SaveIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const CancelIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const StatusSelectWrap = styled(Box)({
  flexShrink: 0,
});
